<template>
  <view-section
    alt-bg
    full-width
    full-height
    no-border
    flex
    :panel-loading="panelLoading"
    :class="`${Classes.STATBOX} game-secondary-button-border-color tw-flex tw-items-center`"
  >
    <div
      class="tw-flex tw-justify-start tw-items-start tw-space-x-2 xl:tw-space-x-4"
    >
      <loading-label v-if="panelLoading" random />
      <div v-else class="tw-leading-5">
        <div
          class="tw-text-sm tw-opacity-70 tw-capitalise xl:tw-whitespace-nowrap"
        >
          {{ title }}
        </div>

        <span
          class="tw-text-h6 xl:tw-text-h5 tw-font-bold xl:tw-whitespace-nowrap"
        >
          <loading-label v-if="panelLoading" random />

          <span v-else>
            <font-awesome-icon
              v-if="icon"
              :icon="icon"
              class="tw-h-4 lg:tw-w-4 xl:tw-size-6 tw-mr-2 game-primary-button-text"
            />
            <div
              v-if="platforms.length"
              class="tw-w-full tw-flex tw-font-normal"
            >
              <tooltip-hover
                v-for="(platform, index) in platformIcons"
                :key="index"
                position="top left"
                :text="platform.text"
              >
                <base-icon :icon="platform.icon" class="tw-mr-1 tw-size-4" />
              </tooltip-hover>
            </div>
            <template v-else-if="formatNumber">
              {{ numberFormatter(text, 1) }}
            </template>
            <template v-else>
              {{ text }}
            </template>
          </span>
        </span>
      </div>
    </div>
  </view-section>
</template>

<script>
import { GAME_PLATFORM_LABELS, PLATFORM_ICONS } from '@config/options.js'
import LoadingLabel from '@components/Loading/LoadingLabel.vue'
import TooltipHover from '@components/Message/TooltipHover.vue'
import ViewSection from '@components/View/ViewSection.vue'
import { numberFormatter } from '@helpers/utils.js'
import Classes from '@shared/js/config/css.js'
import { computed, toRefs } from 'vue'
export default {
  components: {
    LoadingLabel,
    TooltipHover,
    ViewSection,
  },
  props: {
    title: {
      type: String,
      default: '',
    },
    text: {
      type: [Number, String],
      default: '',
    },
    formatNumber: {
      type: Boolean,
      default: false,
    },
    panelLoading: {
      type: Boolean,
      default: true,
    },
    icon: {
      type: String,
      default: '',
    },
    platforms: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    const { platforms } = toRefs(props)

    const platformIcons = computed(() => {
      const icons = []
      platforms.value.forEach((platform) => {
        if (platform === 'source') return

        const icon = PLATFORM_ICONS[platform]
        const text = GAME_PLATFORM_LABELS[platform]
        const iconIndex = icons.findIndex((x) => x.icon === icon)

        if (iconIndex >= 0) {
          icons[iconIndex].text += `, ${GAME_PLATFORM_LABELS[platform]}`
        } else {
          icons.push({ icon, text })
        }
      })
      return icons
    })

    return {
      numberFormatter,
      platformIcons,
      Classes,
    }
  },
}
</script>
